import React, { useState } from "react";
import { Row, Col } from "react-bootstrap"
import axiosService from "../../../utils/axios.service";
import { Table, Button } from 'antd';
import 'antd/dist/antd.min.css'
import Loading from "../../customer/Loading";
import { Tooltip } from "antd";

import "../scss/report.scss"

//Chi tiết Sale - Chi tiết đơn tư vấn
const ViewDetailOrderSaleTvvCtm = (props) => {
    const [showLoading, setShowLoading] = useState(false)
    const [pageSize, setPageSize] = useState(10)
 
    function convertCurrency(data) {
        let res = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data)
        return res;
    };

    const columns = [
        {
            title: 'Ngày giao dịch',
            dataIndex: 'date',
            // align: "center",
            width: 120,
            fixed : 'left',
            render: (data) => {
                return (
                    <p className="text4">{data}</p>
                )
            },
        },
        {
            title: 'Mã hoá đơn',
            dataIndex: 'order_code',
            // align: "center",
            width: 120,
            render: (data) => {
                return (
                    <p className="">{data}</p>
                )
            },
        },
        {
            title: <Tooltip className="show-tooltip" title='Mã giao dịch được sinh ra khi khách hàng thanh toán tại hoá đơn.'> Mã giao dịch <i className="fas fa-info-circle"></i></Tooltip>,
            dataIndex: 'transaction_code',
            // align: "center",
            width: 120,
            render: (data) => {
                return (
                    <p className="text3">{data}</p>
                )
            },
        },
        {
            title: 'Tên khách hàng',
            align: "center",
            width: 200,
            render: (data) => {
                return (
                    <>
                        <p className="">{data.customer_name}</p>
                        <p className="">{data.customer_mobile}</p>
                    </>
                )
            },
        },
        {
            title: <Tooltip className="show-tooltip" title='Tổng số tiền thực tế đã thu được từ các đơn hàng đến từ nguồn Online bằng các phương thức thanh toán chuyển khoản, tiền mặt, quẹt thẻ, sử dụng tiền trong tài khoản, không bao gồm sử dụng điểm tích lũy.'> 
                Tiền đã thu <i className="fas fa-info-circle"></i>
            </Tooltip>,
            dataIndex: 'paid',
            // align: "center",
            width: 150,
            render: (data) => {
                return (
                    <p className="text4">{convertCurrency(data)}</p>
                )
            },
        },
        {
            title: <Tooltip className="show-tooltip" title='Tổng số tiền thực tế đã thu ĐÃ TRỪ THUẾ được từ các đơn hàng đến từ nguồn Online bằng các phương thức thanh toán chuyển khoản, tiền mặt, quẹt thẻ, sử dụng tiền trong tài khoản, không bao gồm sử dụng điểm tích lũy.'>
                Thực thu bán hàng<i className="fas fa-info-circle"></i>
            </Tooltip>,
            dataIndex: 'paidNoTax',
            // align: "center",
            width: 150,
            render: (data) => {
                return (
                    <p className="text4">{convertCurrency(data)}</p>
                )
            },
        },
        {
            title: 'Tên dịch vụ',
            dataIndex: 'product_name',
            width: 250,
            render: (data) => {
                return (
                    <p className="text1">{data}</p>
                )
            },
        },
        {
            title: 'Loại giao dịch',
            dataIndex: 'status',
            width: 120,
            render: (data) => {
                return (
                    <p className="text1">{data}</p>
                )
            },
        },
        {
            title: <Tooltip className="show-tooltip" title='Đơn mới là đơn khách hàng lần đầu mua và thanh toán. Đơn cũ là đơn khách hàng trả nợ hoặc thanh toán những lần về sau.'> Trạng thái đơn hàng <i className="fas fa-info-circle"></i></Tooltip>,
            dataIndex: 'new_order',
            width: 120,
            render: (data) => {
                return (
                    <p className="text1">{data}</p>
                )
            },
        },
        {
            title: 'Cơ sở thanh toán',
            dataIndex: 'store_name',
            align: "center",
            width: 150,
            render: (data) => {
                return (
                    <p className="">{data}</p>
                )
            },
        },
    ];

    const handelExportUser = () => {
        setShowLoading(true)
      
        var url = `api/mysql/export/detail-sale?type=2&user_id=${props.userId}&user_name=${props.userName}&start=${props.startDate}&end=${props.endDate}`
        axiosService(url, "GET")
        .then((res) => {
            if (res.data.code == 200) {
                window.location.href = res.data.data.url
                setShowLoading(false)
            }
        }).catch((error) => {
            console.log(error)
            setShowLoading(false)
        });
    }

    const  handleChange = (e) => {
        setPageSize(e.pageSize)
    }

  
    return (
        <>
            <div style={{ backgroundColor: "white" }} className="p-2">
                
                <div className="border-bottom w-100 pb-2">
                    <Row>
                        <Col xs={6}>
                            <div>
                                Bảng số liệu chi tiết
                            </div>
                        </Col>
                        <Col xs={6}>
                            <Button size="middle" type="primary"
                             onClick={handelExportUser}
                            ><i className="fa-solid fa-file-excel mr-2"></i>Xuất dữ liệu
                            </Button>
                        </Col>
                    </Row>
                </div>
                    
                <Table 
                    columns={columns} 
                    dataSource={props.table}
                    pagination={{ pageSize: pageSize}}
                    scroll={{ x: columns.length*150, y: 600 }}
                    onChange={handleChange}
                    bordered
                    rowKey="key"
                />
            </div>
            <Loading
                show={showLoading}
            ></Loading>
        </>
    )
}
export default ViewDetailOrderSaleTvvCtm